module.exports = __webpack_public_path__ + "static/tt-favicon-9df990f70a43f00c160e58913adcb76b.svg";